import { render, staticRenderFns } from "./createQualification.vue?vue&type=template&id=446082a7"
import script from "./createQualification.vue?vue&type=script&lang=js"
export * from "./createQualification.vue?vue&type=script&lang=js"
import style0 from "./createQualification.vue?vue&type=style&index=0&id=446082a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports